<div class="ms-5 me-5">
  <yc-panel
    [type]="PanelTypes.FormSectionHeader"
    [isFirst]="true"
    [title]="'common:textBbidTiedToAnotherAccount' | ycI18n: 'The Blackbaud ID you signed in with is already associated with an account.'"
    [description]="description">
  </yc-panel>


  <div class="d-flex justify-content-end align-items-center mt-3">
    <!-- Start BBID Over -->
    <yc-button class="me-3"
      [link]="true"
      [langKey]="'APPLY:textStartOver'"
      [defaultText]="'Start over'"
      (onClick)="startBbidOver()"> 
    </yc-button>

    <!-- Sign into Existing BBID Account -->
    <yc-button
      [primary]="true"
      [langKey]="'APPLY:textSignInToExistingAccount'"
      [defaultText]="'Sign into existing account'"
      (onClick)="signInToExistingBbidAccount()">
    </yc-button>
  </div>
</div>